import React from 'react';
import Section from './Section';

const experiences = [
    {
        title: "Full Stack Developer Intern",
        company: "Qualaces Inc.",
        period: "Aug 2024 – May 2025",
        location: "Remote",
        achievements: [
            "Built and deployed jobque.ai using React.js, Flask, and AWS.",
            "Integrated Google OAuth and Stripe for 500+ user sign-ups.",
            "Developed Selenium-based scraping with automated email alerts.",
            "Improved user retention by 22% with responsive UI optimizations."
        ]
    },
    {
        title: "Undergraduate Teaching Assistant",
        company: "Arizona State University",
        period: "Jan 2024 – May 2024",
        location: "Tempe, AZ",
        achievements: [
            "Supported CSE 360 and CSE 365, grading for 750+ students.",
            "Conducted office hours and recitation sessions.",
            "Developed study materials that boosted quiz scores by 10%."
        ]
    }
];

export default function Experience() {
    return (
        <Section id="experience" className="bg-warm-white">
            <h2 className="text-3xl font-serif font-bold text-center text-charcoal mb-16">Experience</h2>

            <div className="max-w-3xl mx-auto space-y-12">
                {experiences.map((exp, idx) => (
                    <div key={idx} className="relative pl-8 md:pl-0 border-l-2 border-warm-grey md:border-none">
                        {/* Timeline dot for mobile, could be cleaner but keeping simple */}
                        <div className="md:hidden absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-earth-brown" />

                        <div className="grid md:grid-cols-[1fr_2px_1fr] gap-8">
                            <div className="text-left md:text-right md:order-1">
                                <h3 className="text-xl font-bold text-charcoal">{exp.company}</h3>
                                <p className="text-earth-brown font-serif italic mb-1">{exp.title}</p>
                                <p className="text-sm text-charcoal/50 uppercase tracking-widest mb-4">{exp.period}</p>
                            </div>

                            {/* Desktop center line */}
                            <div className="hidden md:flex flex-col items-center md:order-2">
                                <div className="w-3 h-3 rounded-full bg-earth-brown"></div>
                                <div className="w-[1px] bg-warm-grey h-full my-2"></div>
                            </div>

                            <div className="md:order-3">
                                <ul className="space-y-2 text-charcoal/80">
                                    {exp.achievements.map((item, i) => (
                                        <li key={i} className="leading-relaxed text-sm">
                                            • {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Section>
    );
}
